module.exports = __webpack_public_path__ + "media/images/sites/health/favicon-120x120-4ceb928ca2224aa63707480d00e9a9d2.png";